import React from 'react';
import { useLanguage } from '../../../../../context/LanguageContext';
import '../style/presentation-section.css';

/**
 * "O Roady Centro-Auto Chaves" presentation block (B5).
 */
const PresentationSection: React.FC = () => {
    const { language } = useLanguage();
    const pt = language === 'pt';

    return (
        <section className="presentation-section">
            <div className="container">
                <div className="section-title text-center">
                    <div className="section-title__tagline-box">
                        <div className="section-title__tagline-border">
                            <div className="section-title__shape-1">
                                <i className="section-title__circle"></i>
                            </div>
                        </div>
                        <h6 className="section-title__tagline">
                            {pt ? 'A Nossa Oficina' : 'Our Workshop'}
                        </h6>
                        <div className="section-title__tagline-border">
                            <div className="section-title__shape-2">
                                <i className="section-title__circle"></i>
                            </div>
                        </div>
                    </div>
                    <h2 className="section-title__title">
                        {pt ? 'O Roady Centro-Auto Chaves' : 'Roady Centro-Auto Chaves'}
                    </h2>
                </div>
                <p className="presentation-section__text">
                    {pt
                        ? 'Estamos em Chaves e é daqui que cuidamos dos carros de quem vive e trabalha na zona. Fazemos revisões, pneus, travões, mudanças de óleo, diagnóstico eletrónico e mecânica geral, com a atenção de quem conhece as exigências do dia a dia: percursos curtos, trânsito de cidade, estrada e autoestrada.'
                        : 'We are in Chaves and it is from here that we take care of the cars of those who live and work in the area. We do servicing, tyres, brakes, oil changes, electronic diagnostics and general mechanics, with the attention of someone who knows the demands of everyday driving: short trips, city traffic, road and motorway.'}
                </p>
                <p className="presentation-section__text">
                    {pt
                        ? 'Vemos o carro, explicamos o que precisa e apresentamos o valor antes de avançar.'
                        : 'We look at the car, explain what it needs and present the price before going ahead.'}
                </p>
            </div>
        </section>
    );
};

export default PresentationSection;
